import angular from 'angular';

MembershipController.$inject = ['$scope', '$uibModal'];

function MembershipController($scope, $uibModal) {
  $scope.membership = {
    model: '',
    showMessageModal: {},

    init: function () {},

    showMessage: function (title, message, success, cancel) {
      const self = $scope.membership;

      if (message) {
        self.showMessageModal = $uibModal.open({
          templateUrl: 'views/application/views/reports/create/modals/showMessage.tpl.html',
          size: 'md',
          controller: 'ReportsCreateShowMessageModalController',
          resolve: {
            currentTitle: function () {
              return title;
            },
            currentMessage: function () {
              return message;
            },
            safe: function () {
              return true;
            },
          },
        });
        // Invoked when modal completes with close(params)
        self.showMessageModal.result.then(
          function (result) {
            if (typeof success === 'function') {
              success(result);
            }
          },
          function (result) {
            // Do nothing
            if (typeof cancel === 'function') {
              cancel(result);
            }
          }
        );
      }
    },

    success: {
      init: function (response) {},
    },

    error: {
      init: function (response) {},
    },
  };

  $scope.membership.init();
}

export const MembershipControllerModule = angular
  .module('acme.view.application.membership.controllers', [
    'ui.bootstrap',
    'acme.view.application.reports.create.showMessageModal.controllers',
  ])
  .controller('MembershipController', MembershipController).name;
